import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
} from "@mui/material";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddCurrencyForm = ({ onClose, onSuccess, initialData }) => {
  console.log("🚀 ~ AddCurrencyForm ~ initialData:", initialData);
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    code: initialData?.code || "",
    symbol: initialData?.symbol || "",
    exchange_rate: initialData?.exchange_rate || 1.0,
    last_price: initialData?.last_price || null,
    is_active: initialData?.is_active || 1,
    id: initialData?.id || null, // Add ID field
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name,
        code: initialData.code,
        symbol: initialData.symbol,
        exchange_rate: initialData.exchange_rate,
        last_price: initialData.last_price,
        is_active: initialData.is_active,
        id: initialData.id,
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.name)) newErrors.name = "يجب إدخال الاسم";
    if (!validateRequired(formData.code)) newErrors.code = "يجب إدخال كود العملة مثل SAR";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateForm()) return;

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          formPayload.append(key, value);
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/currencies/update/${formData.id}`
        : BASE_URL + "/administrator/currencies/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // طباعة تفاصيل الرد
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
      console.log("Status Code:", response.status);
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      console.log("Error Response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      code: "",
      symbol: "",
      exchange_rate: 1.0,
      last_price: null,
      is_active: 1,
    });
    setErrors({});
    onClose();
  };
  return (
    <Box
      sx={{
        p: 3,
        width: 600,
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل العملة" : "إضافة عملة جديدة"}
        </Typography>
      </Box>
      <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        معلومات العملة
      </Typography>
      {/* Main Form */}
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.name} sx={{ mb: 2 }}>
          <TextField
            label="العملة ريال سعودي - دولار امريكي"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="activing">حالة العملة </InputLabel>
          <Select
            labelId="activing"
            name="is_active"
            value={Number(formData.is_active)}
            onChange={handleChange}
            sx={{ height: 43 }}
          >
            <MenuItem value="1">نشط</MenuItem>
            <MenuItem value="0">غير نشط</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth error={!!errors.code} sx={{ mb: 2 }}>
          <TextField
            label="كود العملة SAR "
            name="code"
            value={formData.code}
            onChange={handleChange}
            error={!!errors.code}
            helperText={errors.code}
          />
        </FormControl>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            label="رمز العملة $"
            name="symbol"
            value={formData.symbol}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            label="سعر الصرف"
            name="exchange_rate"
            type="number"
            value={formData.exchange_rate}
            onChange={handleChange}
            inputProps={{ step: "any" }}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            label="السعر السابق"
            name="last_price"
            type="number"
            value={formData.last_price || ""}
            onChange={handleChange}
            inputProps={{ step: "any" }}
          />
        </FormControl>
      </Box>
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="contained" color="error" onClick={handleCancel} sx={{ px: 4 }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important" }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddCurrencyForm;
